module.exports = __webpack_public_path__ + "img/img-exercise-muscle-05.04e33b53.png";